/*
  Kiwi Ears · technology page (Rene 2026-08-31) — sections/tc-*.

  IT TOGGLES MARKUP, IT NEVER BUILDS A PANEL. Every technology, configuration
  and lineup example is a customizer block server-rendered by its section;
  this file only decides which panel shows. Loaded by several sections, so
  the run-once guard is load-bearing.

  THE CHOSEN TECHNOLOGY RIDES THE URL (?tech=dd) and the hero's floating
  chips deep-link into the library. The lineup filter chips are DERIVED from
  the blocks' tags, so a filter can never be offered with nothing behind it
  (same contract as the events chips).
*/
(function () {
  'use strict';
  if (window.__kiwiTech) return;
  window.__kiwiTech = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------- transducer library */
  var lib = $('[data-tc-lib]');
  if (lib) {
    var tabs = $$('[data-tc-tab]', lib);
    var panels = $$('[data-tc-panel]', lib);

    var selectTech = function (key, writeUrl) {
      var found = false;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-tc-panel') === key;
        p.hidden = !on;
        if (on) found = true;
      });
      if (!found) return false;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tc-tab') === key;
        t.setAttribute('aria-selected', String(on));
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (writeUrl && window.history && history.replaceState) {
        var url = new URL(location.href);
        url.searchParams.set('tech', key);
        history.replaceState(null, '', url);
      }
      return true;
    };

    lib.addEventListener('click', function (e) {
      var t = e.target.closest('[data-tc-tab]');
      if (t) selectTech(t.getAttribute('data-tc-tab'), true);
    });
    lib.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var cur = tabs.indexOf(document.activeElement);
      if (cur === -1) return;
      e.preventDefault();
      var next = (cur + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
      tabs[next].focus();
      selectTech(tabs[next].getAttribute('data-tc-tab'), true);
    });

    /* the hero's floating chips: select the technology AND travel there */
    document.addEventListener('click', function (e) {
      var jump = e.target.closest('[data-tc-jump]');
      if (!jump) return;
      if (selectTech(jump.getAttribute('data-tc-jump'), true)) {
        lib.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });

    try {
      var q = new URL(location.href).searchParams.get('tech');
      if (q) selectTech(q.toLowerCase(), false);
    } catch (err) { /* URL API missing: first tab stands */ }
  }

  /* ---------------------------------------------- architecture explorer */
  var hyb = $('[data-tc-hybrid]');
  if (hyb) {
    hyb.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tc-config]');
      if (!b) return;
      var key = b.getAttribute('data-tc-config');
      $$('[data-tc-config-panel]', hyb).forEach(function (p) {
        p.hidden = p.getAttribute('data-tc-config-panel') !== key;
      });
      $$('[data-tc-config]', hyb).forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
    });
  }

  /* --------------------------------------------------- lineup filtering */
  var lineup = $('[data-tc-lineup]');
  if (lineup) {
    var wrap = $('[data-tc-filters]', lineup);
    var cells = $$('[data-tc-cell]', lineup);
    if (wrap && cells.length) {
      var tokens = [];
      cells.forEach(function (c) {
        (c.getAttribute('data-tech') || '').split(/\s+/).forEach(function (t) {
          if (t && tokens.indexOf(t) === -1) tokens.push(t);
        });
      });
      var mkChip = function (label, value, pressed) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tc-chip';
        b.setAttribute('data-tc-filter', value);
        b.setAttribute('aria-pressed', String(pressed));
        b.textContent = label;
        return b;
      };
      wrap.appendChild(mkChip(wrap.getAttribute('data-all-label') || 'All', '', true));
      tokens.forEach(function (t) { wrap.appendChild(mkChip(t.toUpperCase(), t, false)); });

      lineup.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tc-filter]');
        if (!b) return;
        var v = b.getAttribute('data-tc-filter');
        $$('[data-tc-filter]', lineup).forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        cells.forEach(function (c) {
          var techs = (c.getAttribute('data-tech') || '').split(/\s+/);
          c.hidden = !!v && techs.indexOf(v) === -1;
        });
      });
    }
  }

  /* --------------------------------------------------- tuning layers */
  $$('[data-tc-layers]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('[data-tc-graph]');
      if (!card) return;
      var next = !card.classList.contains('show-layers');
      card.classList.toggle('show-layers', next);
      btn.setAttribute('aria-pressed', String(next));
      btn.textContent = btn.getAttribute(next ? 'data-hide' : 'data-show') || btn.textContent;
    });
  });

  /* ------------------------------------------------------------ reveals */
  function reveals() {
    if (!window.gsap || !window.ScrollTrigger) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    window.gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', function () {
      $$('[data-tc-rev]').forEach(function (el) {
        window.gsap.fromTo(el, { autoAlpha: 0, y: 22 }, {
          autoAlpha: 1, y: 0, duration: 0.7, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 92%', once: true }
        });
      });
    });
  }
  if (window.gsap && window.ScrollTrigger) reveals();
  else {
    var tries = 0;
    var poll = setInterval(function () {
      if ((window.gsap && window.ScrollTrigger) || tries++ > 40) { clearInterval(poll); reveals(); }
    }, 100);
  }
})();
